import { createAction } from '@reduxjs/toolkit';

function getSelectedElementsData (selectedElements) {
  const elements = Array.isArray(selectedElements) ? selectedElements : [];

  return elements.map(element => ({
    data: { ...element.dataset },
    id: element.id
  }));
}

export const setSelectedElements = createAction('canvas/set_selected_element', elements => ({
  payload: getSelectedElementsData(elements)
}));
